import { render, staticRenderFns } from "./semifished-ingredient-table.vue?vue&type=template&id=d9a8292c&"
import script from "./semifished-ingredient-table.vue?vue&type=script&lang=js&"
export * from "./semifished-ingredient-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports